'use strict';

/**
 * window.performance wrappers (for tests mainly)
 */
export default {
  getNavigation() {
    return (window && window.performance) ? window.performance.navigation : {};
  },

  getTiming() {
    return (window && window.performance) ? window.performance.timing : {};
  },

  /**
   * Duration relative to navigation start (window.performance.timing.navigationStart)
   */
  now() {
    return (window && window.performance && window.performance.now) ? window.performance.now() : new Date().getTime();
  },

  /**
   * Create a performance timestamp
   */
  mark(name) {
    window &&
      window.performance &&
      window.performance.mark &&
      window.performance.mark(name);
  },

  /**
   * Record a performance measurement
   */
  measure(name, startMark, endMark) {
    window &&
      window.performance &&
      window.performance.measure &&
      window.performance.measure(name, startMark, endMark);
  }
};



// WEBPACK FOOTER //
// ./performance/performance.js